// Module
var code = "<div class=\"mx-dashboard-report\">\r\n\t<mx-dashboard-page dashboard-loader=\"vm.dashboardLoader\" data-component-id=\"vm.id\" data-report-mode=\"true\" data-on-initialized=\"vm.onInitialized(dashboard)\"></mx-dashboard-page>\r\n</div>";
// Exports
export default code;